import { render, staticRenderFns } from "./AccessoryCard.vue?vue&type=template&id=1f8f7d6b&scoped=true"
import script from "./AccessoryCard.vue?vue&type=script&lang=js"
export * from "./AccessoryCard.vue?vue&type=script&lang=js"
import style0 from "./AccessoryCard.vue?vue&type=style&index=0&id=1f8f7d6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8f7d6b",
  null
  
)

export default component.exports